import * as React from "react";
import {
  PRACTICES,
  getPracticeByUuid,
  getCurrentPracticeId,
  practicesService,
  setCurrentPracticeId,
  type Practice,
} from "../services/practices.service.ts";

interface PracticeContextValue {
  practice: Practice;
  practices: Practice[];
  setPractice: (uuid: string) => void;
}

const PracticeCtx = React.createContext<PracticeContextValue | null>(null);

export function PracticeProvider({ children }: { children: React.ReactNode }) {
  const [practiceUuid, setPracticeUuid] = React.useState(getCurrentPracticeId);

  const practice = getPracticeByUuid(practiceUuid) ?? PRACTICES[0]!;

  React.useEffect(() => {
    setCurrentPracticeId(practice.uuid);
  }, [practice.uuid]);

  const setPractice = React.useCallback((uuid: string) => {
    if (!getPracticeByUuid(uuid)) return;
    setCurrentPracticeId(uuid);
    setPracticeUuid(uuid);
  }, []);

  const value = React.useMemo(
    () => ({
      practice,
      practices: practicesService.list(),
      setPractice,
    }),
    [practice, setPractice],
  );

  return <PracticeCtx.Provider value={value}>{children}</PracticeCtx.Provider>;
}

export function usePractice(): PracticeContextValue {
  const ctx = React.useContext(PracticeCtx);
  if (!ctx) {
    throw new Error("usePractice must be used within PracticeProvider");
  }
  return ctx;
}
